
define('text!templates/widgets/dataGridCells/i18nCell.html',[],function () { return '<span data-bind="lString: { name: name, data: data }"></span>';});

